module.exports = __webpack_public_path__ + "static/media/zwzproduct13.770eaec2.jpg";